<template>
    <div class="ave__search">
        <div class="ave__search__results" v-if="results">
            <div v-if="results && results.length === 0">
                <span class="ave__search__result-count">{{ $t('noResult') }}</span>
            </div>
            <template v-else>
                <div class="row">
                    <div class="col-12">
                        <global-loading-overlay :showLoading="text_freeze">
                            {{ $t('loading') }}
                        </global-loading-overlay>
                        <div class="row">
                            <div class="col-12">
                                <span class="ave__search__result-count">{{ resultCount }} {{ $t('totalResults') }}</span>
                                <div class="ave__search__results--decoration">

                                </div>
                            </div>
                        </div>
                        <div class="row ave__search__items">
                            <div v-for="(product, index) in results"
                                 class="col-6 col-md-3 col-lg-2"
                                 v-show="page === groupTiles(index)"
                            >
                                <global-material-tile v-show="page === groupTiles(index)" :entity="product"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ave__pagination">
                    <span class="pagination__indicator">{{ decorsShown }}</span>
                    <global-button icon="arrow-left" @click="changePage(page-1, 'prev')" theme="secondary"
                                   :class="page-1 < lowerEnd ? 'disabled': ''" class="ignore-context pagination--prev"/>
                    <global-button icon="arrow-right" @click="changePage(page+1, 'next')" theme="secondary"
                                   :class="page+1 > upperEnd ? 'disabled': ''" class="ignore-context pagination--prev"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import GlobalButton from "@global/global-elements/global-button/global-button";
import GlobalMaterialTile from "@global/global-elements/global-material-tile/global-material-tile.vue"
import {detectBreakpoint} from "@utilities/sal-breakpoint/sal-breakpoint";
import GlobalLoadingOverlay from '@global/global-elements/global-loading-overlay/global-loading-overlay';
import {track_abstract, tracking_events} from '@utilities/track-abstract/track-abstract';

const tilesPerPageConfiguration = {
    'xs': 4,
    'sm': 4,
    'md': 4,
    'lg': 6,
    'xl': 6
}

export default {
    name: "AveSearch",
    components: {GlobalLoadingOverlay, GlobalButton, GlobalMaterialTile},
    data: function () {
        return {
            page: 0,
            tilesPerPage: 6,
            controller: null,
            results: false,
            resultCount: null,
            text_freeze: false,
            text_timeout: false
        }
    },
    props: {
        query: ''
    },
    computed: {
        decorsShown() {
            return (this.page * this.tilesPerPage + 1) + ' - ' + (((this.page * this.tilesPerPage + this.tilesPerPage) > this.resultCount) ? this.resultCount : this.page * this.tilesPerPage + this.tilesPerPage);
        },
        upperEnd() {
            return Math.ceil(this.resultCount / this.tilesPerPage) - 1;
        },
        lowerEnd() {
            return 0
        }
    },
    watch: {
        query: function (newVal) {
            if (this.controller) {
                this.controller.abort();
            }
            if (newVal && newVal.length > 0) {
                this.results = [];
                this.text_freeze = true;
                this.controller = new AbortController();
                fetch(window.AVE_API
                    + '&tx_salbase9_search[q]=' + encodeURIComponent(newVal)
                    + '&tx_salbase9_search[num]=' + (this.tilesPerPage),
                    {signal: this.controller.signal})
                    .then((response) => response.json())
                    .then((json) => {
                        if (json.decor && Array.isArray(json.decor.docs)) {
                            let tmpResults = [].concat(json.decor.docs, json.boards.docs);
                            tmpResults.sort((A, B) => {
                                return B.score - A.score;
                            });
                            this.page = 0;
                            this.results = tmpResults;
                            this.resultCount = json.decor.count + json.boards.count;
                            track_abstract.trigger_event(tracking_events.SearchAvailabilityEntrypage, newVal);
                        } else {
                            this.results = [];
                        }
                        this.text_freeze = false;
                    })
                    .catch(e => {/* In most cases, the request was just aborted */});
            } else {
                this.results = false;
            }
        }
    },
    methods: {
        groupTiles(index) {
            return Math.floor(index / this.tilesPerPage)
        },
        updateResults(page) {
            if (this.results.length === this.resultCount) {
                return;
            }

            fetch(window.AVE_API
                + '&tx_salbase9_search[q]=' + encodeURIComponent(this.query)
                + '&tx_salbase9_search[start]=' + ((page) * this.tilesPerPage)
                + '&tx_salbase9_search[num]=' + (this.tilesPerPage),
                {signal: this.controller.signal})
                .then((response) => response.json())
                .then((json) => {
                    if (json.decor && Array.isArray(json.decor.docs)) {
                        let tmpResults = [].concat(json.decor.docs, json.boards.docs);
                        tmpResults.sort((A, B) => {
                            return B.score - A.score;
                        });
                        this.results = this.results.concat(tmpResults);
                    }
                    this.text_freeze = false;
                }).catch(e => {/* In most cases, the request was just aborted */
            });
        },
        changePage(index, direction) {
            let normalizedPage = index < this.lowerEnd ? this.lowerEnd : index;
            normalizedPage = index > this.upperEnd ? this.upperEnd : normalizedPage;
            this.page = normalizedPage;

            if (direction === 'next') {
                this.updateResults(normalizedPage)
            }
        }
    },
    mounted() {
        this.tilesPerPage = tilesPerPageConfiguration[detectBreakpoint()] ? tilesPerPageConfiguration[detectBreakpoint()] : 99999999
        window.addEventListener('resize', () => {
            const oldTilePage = this.tilesPerPage;

            this.tilesPerPage = tilesPerPageConfiguration[detectBreakpoint()] ? tilesPerPageConfiguration[detectBreakpoint()] : 99999999
            this.changePage(Math.floor(this.page * oldTilePage / this.tilesPerPage));
        });
    }
}
</script>
